module.exports = __webpack_public_path__ + "static/media/july_2025_2.1e8a1420.webp";